export default __webpack_public_path__ + "static/cars_banner-c2db7431c6c05338d6af55d5bff4f3ea.png";